// extracted by mini-css-extract-plugin
var _1 = "MyFundsStyles-module__fundsPage___ccOAS";
var _2 = "MyFundsStyles-module__fundsPageHeader___No5H1";
var _3 = "MyFundsStyles-module__headerButtonsWrapper___YhEyt";
var _4 = "MyFundsStyles-module__headerTitleWrapper___CkZaY";
var _5 = "MyFundsStyles-module__tabWrapper____HTyl";
export { _1 as "fundsPage", _2 as "fundsPageHeader", _3 as "headerButtonsWrapper", _4 as "headerTitleWrapper", _5 as "tabWrapper" }
